<template lang="pug">
  div.report-content
    h2 臺灣身材審美轉變
    p 我們不見得是「胖子」，但多少都有嫌棄自己「胖」的時候，也常常警惕自己「不能胖」。處在一個懼怕肥胖、拒絕變胖的時代，到底是誰定義胖不好、不美、不健康？
    template(v-for="txt in txts")
      h4(v-html="txt.title")
      div(v-html="txt.content")
    div.report-content__reference
      p <ReportNotation :notation="notations[0]">引用資料來源</ReportNotation>
</template>

<script>
import ReportNotation from '../common/ReportNotation.vue'

export default {
  name: 'ReportContent1',
  components: {
    ReportNotation
  },
  data () {
    return {
      txts: [
        {
          title: '1920 th<br>傳統東方體態：束胸的平坦美',
          content: '<p>臺灣早期的傳統婦女間盛行著束胸的風氣，普遍價值觀認為：「不展示出胸部的女性身材，才符合美的標準。」內衣以讓胸部看起來平坦的肚兜為主，身材有點小腹也沒關係。</p>'
        },
        {
          title: '1930 th<br>西方審美觀傳入：凹凸有致的曲線美',
          content: '<p>日治時期的年輕女性開始穿洋服。西方女性追求挺胸、纖腰、翹臀的身材，內衣與服飾強調身體的曲線，衝擊民眾的穿衣習慣與美觀的定義。臺灣人對身體美的思維逐漸轉變。</p>'
        },
        {
          title: '1940 th<br>瘦不健康   胖是福氣',
          content: '<p>戰後初期經濟狀況普遍不佳，四〇年代的臺灣幾乎沒有一個肥胖孩童。社會對於肥胖抱有好感，象徵個人的能力、財富和福氣，甚至與正面的健康形象做連結；削瘦才是人們關注的健康議題。</p>'
        },
        {
          title: '1950 th<br>成衣限縮身體樣貌   醫療背書胖不健康',
          content: '<p>臺灣早年的服飾以量身訂製為主，什麼樣的身材都不怕沒有好看的衣服穿。五〇年代紡織工業興起，為了提升生產效率設計出規格化的標準尺碼，人們必須改變體態才能穿得美。</p><p>研究發現，五〇年代的臺灣報紙上刊登大量譯自西方報紙與醫療文獻，指出肥胖對健康有重大負面影響的報導，將肥胖形塑為增加罹患疾病機率的警示，甚至與死亡有所牽連。</p>'
        },
        {
          title: '1960 th<br>公眾人物勵志減肥   瘦身風氣萌芽',
          content: '<p>國內醫師對肥胖影響健康的見解在六〇年代加入，報章雜誌上也出現許多演藝人員、高社經地位者的減肥人物報導，帶起臺灣社會的瘦身風氣。</p>'
        },
        {
          title: '1970 th<br>肥胖污名化',
          content: '<p>肥胖不再象徵健康福氣，基於認定肥胖理當由當事人負責，人們責怪胖子懶惰、貪吃、自制力差，並將肥胖與病態、醜陋、笨重連結。</p>'
        },
        {
          title: '1980 th<br>臺灣人體重大幅成長   政府推動減肥政策',
          content: '<p>八〇年代臺灣經濟起飛、人民生活水平提高，因此肥胖人口也不斷增加，使得政府部門不得不關切相關議題，開始積極訂定防治肥胖的策略，減肥風氣也席捲臺灣。</p>'
        },
        {
          title: '1990 th<br>廣告宣告瘦就是美   開啟懼／拒胖時代',
          content: '<p>九〇年代以後，臺灣社會經濟力提升、價值觀開放與塑身醫療科技進步。瘦身工業趁著相關規範尚未建立的空窗期，釋出大量廣告形塑瘦身迷思，製作「批判胖的缺點」的內容，為體型較胖的人營造出相當負面的社會環境。</p>'
        },
        {
          title: '2000 th<br>臺灣女性體型焦慮嚴重',
          content: '<p>多項調查指出，肥胖帶來的社會壓力非常高，並特別針對年輕女性。 臺灣人理想的女性體態過於纖瘦，導致臺女時常憂慮自己的體態是否標準、容易對身材感到不安，而且過於懼怕肥胖。</p>'
        },
        {
          title: '2010 th - now<br>健身風氣興起   追求健美肌肉線條',
          content: '<p>歷經超過 80 年的時間，臺灣社會才建立出當今大眾偏愛的身材審美觀。近年的體型審美觀也有些轉變，人們開始擺脫「瘦就是美」的思維，正面認同勤奮健身下打造的精實體態。</p><p>不過，多數人仍以非常負面和歧視的觀點解讀肥胖身材。臺灣社會未來的體態審美觀，還會如何轉變呢？</p>'
        }
      ],
      notations: [
        {
          txt: '<p>林月美、朱志良、洪清霖、黃伯超（1985）。〈台灣地區青少年之營養狀態評估〉，《中華民國營養學會雜誌》，10（3,4）：91-105。</p><p>張錦華（2000）。〈1982 至 1999 台灣瘦身廣告研究——多面向的研究〉。《廣告學研究》，15：67-114。</p><p>張錦華（2002）。《女為悅己者瘦？媒介效果與主題研究》，台北：正中書局。</p><p>謝寒琪（2003）。《一個肥胖兒童的故事——肥胖兒童的人際關係與自我認同》。國立花蓮師範學院國民教育研究所碩士論文。</p><p>鄒孟婷（2006）。〈臺灣成年女性肥胖、自覺肥胖和健康知識與教育程度之關係〉，《臺灣家庭醫學雜誌》，16（4）：237-250。</p><p>陳盈璇（2007）。內衣、身體與社會——台灣女性身體美感的論述流變（1940-1960）。國立交通大學社會與文化研究所碩士論文。</p><p>王雅玄、陳亮君（2010）。〈肥胖污名認同的行程與受壓迫經驗〉，《國立政治大學「教育與心理研究」》，33（2）：61-87。</p><p>謝莉君（2016）。《胖女性的身體實踐、抵抗策略和主體認知歷程》，世新大學性別研究所碩士論文。</p><p>葉家瑜（2017）。《告別肥胖：從戰後台灣報紙的內容看減肥觀念的形塑與實踐》，中央大學歷史研究所碩士論文。</p>',
          display: 'block'
        }
      ]
    }
  },
  mounted () {
    this.$emit('loaded')
  }
}
</script>

<style lang="stylus">
</style>
